import css from './Success.module.scss';

export default function Success({ text, callback }: any) {
    return (
        <dialog className={`success ${css.success}`}>
            <div className="content">
                <div className="content-header">
                    <svg className="close" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" onClick={callback}>
                        <path d="M6 5L19 18M19 5L6 18" stroke="black" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <div className="content-body">
                    <p className="text">{text}</p>
                </div>
            </div>
        </dialog>
    );
}
